/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import { useState, useEffect } from 'react'

const useDetectBrowserTabFocus = () => {
  const [focused, setFocused] = useState(true)

  const init = () => {
    const browserKeysArray = [
      {
        stateKey: 'hidden',
        eventKey: 'visibilitychange',
      },
      {
        stateKey: 'webkitHidden',
        eventKey: 'webkitvisibilitychange',
      },
      {
        stateKey: 'mozHidden',
        eventKey: 'mozvisibilitychange',
      },
      {
        stateKey: 'msHidden',
        eventKey: 'msvisibilitychange',
      },
    ]
    const browserObject = browserKeysArray.find((obj) => {
      if (obj.stateKey in document) {
        return obj
      }
    })
    return {
      listen: (callBack) => {
        if (callBack) {
          document.addEventListener(browserObject.eventKey, callBack)
        }
      },
      isVisible: () => {
        return !document[browserObject.stateKey]
      },
      remove: (callBack) => {
        document.removeEventListener(browserObject.eventKey, callBack)
      },
    }
  }

  useEffect(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const focusDetector = init()
      const handleFocus = () => {
        if (focusDetector.isVisible()) {
          setFocused(true)
        } else {
          setFocused(false)
        }
      }
      focusDetector.listen(handleFocus)

      return () => {
        focusDetector.remove(handleFocus)
      }
    }
  }, [])

  return focused
}

export default useDetectBrowserTabFocus
